import styled from '@emotion/styled';
import { tokens, Button } from '@hotjar/hotsauce';
import type { ButtonProps } from '@hotjar/hotsauce';

const StyledButton = styled(Button)`
  color: ${tokens.color.primary_cta};
`;

export const WidgetGhostButton = ({ children, ...props }: ButtonProps): JSX.Element => {
  return (
    <StyledButton {...props} kind="ghost">
      {children}
    </StyledButton>
  );
};
